<template>
  <div class="personal-container">
    <Header></Header>
    <logo-header title="个人中心"></logo-header>
    <div class="personal-main">
      <router-view></router-view>
    </div>
    <div class="foot-container">
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import Header from 'base/xb-base/Header';
import LogoHeader from 'base/xb-base/LogoHeader';
import Footer from 'base/xb-base/Footer';
export default {
  components: {
    Header,
    LogoHeader,
    Footer
  }
};
</script>
<style lang='scss' scoped>
.personal-container {
  position: relative;
  min-height: 100vh;
  .personal-main {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 20px;
  }
  /* .foot-container {
    position: absolute;
    bottom: 0;
    height: 240px;
    width: 100%;
  } */
}
</style>
